import { completed } from '#components/generics/js/completion/list/list.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import blur from '@mailobj-browser/front/js/events/types/blur.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const onBlur = object(listener, {
  type: blur,
  passive,
  task: async (
    input
  ) => {
    try {
      await completed()
    } catch {}

    await edit(input)
  }
})

const edit = async (
  input,
  value = input.value
) => {
  if (!value.trim()) {
    return
  }

  const fields = closest(`[data-contract~="xaddrs.edit"]`, input)
  const displayNameInput = one(`[name="edit_new_display_name"]`, fields)

  if (value.includes('<')) {
    const parts = value.split('<')
    const displayName = parts[0].trim().replace(/^["']|["']$/g, '')
    const email = parts[1].replace('>', '').trim()

    displayNameInput.value = displayName
    input.value = email
  }
}

export default (fields) => {
  const input = one(`[name="edit_new_email"]`, fields)

  onBlur.listen(input)
}
